import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { IWatchFullInfoContext, WatchFullInfoContext } from '../../../watchFullInfoState/watchFullInfoContext';
import style from './EditBtn.module.scss';

export const EditBtn: React.FC = () => {
	const { watchFullInfo } = useContext<IWatchFullInfoContext>(WatchFullInfoContext);

	return (
		<Link to={`/watches/edit?watchID=${watchFullInfo?.id}`} data-test="EditBtn">
			<Button
				className={style.btn}
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#pencil`} />
					</svg>
				}>
				<Text translationNameSpace="form" translationKey="editWatchButton" asFragment={true} />
			</Button>
		</Link>
	);
};
